import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { httpRequest, queryClient } from '@hc/utils';
import toast from 'react-hot-toast';
import create from 'zustand';

export const constructDrugData = (data) => {
  const allergiesTableData = data.map((val) => ({
    value: val,
    id: val?.id ?? 0,
    goal_name: val?.goal_name ?? '',
    status: val?.is_active ?? false,
    updated_at: val?.updated_at ?? '',
    created_at: val?.created_at ?? '',
  }));
  return allergiesTableData;
};

export const useGoalCategory = create((set, get) => ({
  goalData: [],
  goalCount: 0,
  goal_id: '',
  goal_name: '',
  loading: false,
  error: {
    goal_name: '',
  },

  // ------------- STORE METHODS ------------------
  getGoalCategory: async (search = '', limit = 10, offset = 0) => {
    try {
      set({ loading: true });
      const { data } = await queryClient.fetchQuery({
        queryKey: ['getGoalCategory', search, offset],
        queryFn: async () => {
          const response = await httpRequest(
            'get',
            `${envConfig.api_url}/backofficeMaster/goals/get/all?search=${search}&limit=${limit}&offset=${offset}`,
            {},
            true
          );
          return response;
        },
        staleTime: Infinity,
      });
      if (data?.status?.code === 200) {
        set(() => ({
          goalData:
            Array.isArray(data?.data?.goal_data) &&
            data?.data?.goal_data?.length > 0
              ? constructDrugData(data?.data?.goal_data)
              : [],
          goalCount: data?.data?.goal_count,
        }));
      }
      set(() => ({ loading: false }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          '❌ Some thing went wrong plesae try again!'
      );
    }
  },

  goalCategoryUpdate: async (payload) => {
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/goals/status/update`,
        payload,
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? 'Goal Category Updated Successfully'
        );
      }
      set({ loading: false });
      return data?.status?.code;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
  addEditGoalCategory: async () => {
    const { goal_name, goal_id: id } = get();
    const type = id ? 'Update' : 'Add';
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/goals/upsert`,
        { id: id || '', goal_name },
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? `Goal Category Data ${type} Successfully`
        );
      }
      set({ loading: false });
      return data;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },

  handleChange: (value) => {
    set({ goal_name: value });
  },
  isIamValidToSave: () => {
    const { goal_name, error } = get();
    if (!goal_name) {
      error.goal_name = 'Please enter your Goal Category name';
    } else {
      error.goal_name = '';
      return true;
    }
  },

  initialEditGoalCategory: (value) => {
    set({
      goal_name: value.goal_name ?? '',
      goal_id: value.id ?? '',
    });
  },

  clearGoalCategory: () => {
    set({
      goal_name: '',
      goal_id: '',
    });
  },
}));
